import { useSelector } from "react-redux";
import { isFeatureEnabled } from "../../redux/slice/dashboardSlice";

export const withFeature = (BaseComponent, feature = "") => {
  return (props) => {
    const isEnabled = useSelector(isFeatureEnabled(feature));
    return <BaseComponent {...props} isDisabled={!isEnabled} />;
  };
};
